import { fetchGet, fetchPost } from './index';
import axios from './index'
import HOST  from './host';
const { gtctx, gnctx, gwctx } = HOST;
export function fetchQueryFN(data) {
    return fetchGet(`${gtctx}/page/weight/query`, data).then((res) => {
        return res || {};
    });
}
export function fetchQueryFNNew(data) {
    return fetchGet(`${gnctx}/bigcourse/abShowCheck`, data).then((res) => {
        return res || {};
    });
}
//https://gate.lagou.com/v1/neirong/kaiwu/getBUserInfo
export function fetchUserInfo(data) {
    return fetchGet(`${gtctx}/getUserInfo`, data).then((res) => {
        return res || {};
    });
}
// 面试直通卡
export function postIsBuyCourse() {
    return fetchPost(`${gtctx}/isBuyCourse`, {
        courseIds: [1154]
    }).then((res) => {
        return res
    })
}

// 7天VIP
// export function postIsBuyCourse() {
//     return fetchGet(`${gtctx}/coupon/couponUserHttpLink?couponId=DDA33DFB1F51675A2C303C42F24B4483`).then((res) => {
//         return res
//     })
// }

// 获取已预约用户信息
export function fetchUserList(data) {
  return fetchGet(`${gnctx}/bigcourse/getBigCourseAppointmentInfo`, data).then((res) => {
      return res || {};
  });
}

// 是否参与砍价活动
export function hasJoin(data) {
    return fetchGet(`${gtctx}/activity/bigcourse/hasJoin`, data).then((res) => {
        return res || {};
    });
  }
export function fetchSuccessUrlV2(params) {
    return fetchGet(`${gnctx}/pay/successUrlV2`, params);
}

// 大厂私教24小时内是否提交表单
export function judgeSubmit(data) {
    return fetchPost(`${gnctx}/edu/crm/from/judgeSubmit`, data).then((res) => {
        return res || {};
    });
  }

// 提交大厂私教表单
export function privateEducationV2(data) {
    return fetchPost(`${gnctx}/edu/crm/from/privateEducationV2`, data).then((res) => {
        return res || {};
    });
  }
// 学科列表
export function subjectList(data) {
    return fetchGet(`${gnctx}/kaiwu/crmForm/subjectList`, data).then((res) => {
        return res || {};
    });
};
// 是否购买过面试诊断卡
export function purchasedCourse(data) {
    return fetchGet(`${gtctx}/course/distribution/purchased/course`, data).then((res) => {
        return res || {};
    });
};
// 注销账号
export function unregister(data) {
    return fetchGet(`${gwctx}/entry/account/apply/h5/cancel.json`, data).then((res) => {
        return res || {};
    });
};
// 注销账号
export function getExpectedPosition(data) {
    return fetchGet(`${gtctx}/user/getExpectedPosition`, data).then((res) => {
        return res || {};
    });
};
//预约课程
export function appointmentPublicCourse(data) {
    return fetchPost(`${gtctx}/publiccourse/appointmentPublicCourse`, data).then((res) => {
        return res || {};
    });
}
// 获取大课优惠券
export function getBigCourseCoupon(data) {
    return fetchGet(`${gtctx}/torchplan/getBigCourseCoupon`, data).then((res) => {
        return res || {};
    });
};
// 获取签到优惠券
export function getSignInCoupon(data) {
    return fetchGet(`${gtctx}/torchplan/getSignInCoupon`, data).then((res) => {
        return res || {};
    });
};
// 领取大课优惠券(训练营/私教)
export function receiveBigCourseCoupon(data) {
    return fetchPost(`${gtctx}/torchplan/receiveBigCourseCoupon`, data).then((res) => {
        return res || {};
    });
}
// 领取签到优惠券
export function receiveSignInCoupon(data) {
    return fetchPost(`${gtctx}/torchplan/receiveSignInCoupon`, data).then((res) => {
        return res || {};
    });
}
// 优惠券信息
export const getCouponInfo = (data) => {
    return fetchGet(`${gnctx}/edu/coupon/couponUserHttpLink`, data);
};

// 领取优惠券
export const receiveToPersonal = (data) => {
    return fetchGet(`${gnctx}/edu/coupon/receiveToPersonal`, data);
};
// 获取课程列表
export const getCourseList = (data) => {
    return fetchGet(`${gnctx}/edu/may20/getCourseList`, data);
};
// 查询邀请列表
export const getInviteRecords = (data) => {
    return fetchGet(`${gnctx}/edu/may20/getInviteRecords`, data);
};
// 生成邀请链接
export const getShareUrl = (data) => {
    return fetchGet(`${gnctx}/edu/may20/getShareUrl`, data);
};
// 能否领取VIP
export function preReceiveVip(data) {
    return fetchPost(`${gnctx}/edu/may20/preReceiveVip`, data).then((res) => {
        return res || {};
    });
}
// 领取VIP
export function receiveVip(data) {
    return fetchPost(`${gnctx}/edu/may20/receiveVip`, data).then((res) => {
        return res || {};
    });
}
// 查询邀请信息
export function getInviter(data) {
    return fetchPost(`${gnctx}/edu/may20/getInviter`, data).then((res) => {
        return res || {};
    });
}